import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/analytics';
import 'firebase/performance';

const firebaseConfig = {
    apiKey: "AIzaSyCjRzn2g9vpxMwqW7SZR9IT0HXVJXD0jpA",
    authDomain: "examined-87138.firebaseapp.com",
    databaseURL: "https://examined-87138.firebaseio.com",
    projectId: "examined-87138",
    storageBucket: "examined-87138.appspot.com",
    messagingSenderId: "722507195779",
    appId: "1:722507195779:web:1df6e6071b10cbf52002b6",
    measurementId: "G-PCBJEE2EJ5"
  };

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const auth = firebase.auth();
const perf = firebase.performance();

const usersCollection = db.collection('users');
//const assessmentsCollection = db.collection('assessments');
//const itemsCollection = db.collection('items');
const assessments2Collection = db.collection('coleta2_testes_concluidos');
const itemsColeta2Collection = db.collection('coleta2');

const firestore = firebase.firestore;

firebase.analytics();

export {
    db,
    auth,
    usersCollection,
    assessments2Collection,
    itemsColeta2Collection,
    firebase,
    firebaseConfig,
    firestore,
}